import React, { useEffect } from "react";
import { ReactComponent as ActiveStudentsIcon } from "../../../../assets/icons/report/activeStudent.svg";
import { useDispatch, useSelector } from "react-redux";
import { getContinuesStudentsCountForEachCourse } from "../../../../redux/actions/reportActions";
import Tooltip from "@mui/material/Tooltip";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useState } from "react";

const studentStatus = [
  {
    key: "continue",
    name: "Aktiv tələbə",
  },
  {
    key: "stopped",
    name: "Dayandıran tələbə",
  },
  {
    key: "freeze",
    name: "Donduran tələbə",
  },
];

const ActiveStudentsCard = () => {
  const dispatch = useDispatch();
  const [selectedStatus, setSelectedStatus] = useState("continue");

  const { continuesStudentsCountForCourse: activeStudents } = useSelector(
    (state) => state.reportDatas
  );

  const activeStudentsCount = activeStudents?.reduce(
    (acc, curr) => acc + curr.studentsCount,
    0
  );

  useEffect(() => {
    dispatch(getContinuesStudentsCountForEachCourse(selectedStatus));
  }, [selectedStatus]);

  return (
    <div className="active-students-card ">
      <FormControl fullWidth sx={{ mb: 2, padding: 0 }}>
        <InputLabel id="demo-simple-select-label">Status</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={selectedStatus}
          label="Status"
          onChange={(e) => setSelectedStatus(e.target.value)}
          sx={{ fontSize: 12 }}
        >
          {studentStatus.map((status, i) => (
            <MenuItem key={i} value={status.key} sx={{ fontSize: 12 }}>
              {status.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <div className="student-count">
        <h4>{activeStudentsCount ? activeStudentsCount : 0}</h4>
        <div className="active-student-img-container">
          <ActiveStudentsIcon />
        </div>
      </div>
      <div className="student-count-for-lessons">
        {activeStudents?.map((course) => (
          <div key={course.courseId} className="student-for-lesson">
            <Tooltip
              title={course.courseName}
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    fontSize: "16px",
                    padding: "10px",
                  },
                },
              }}
            >
              <h4
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  width: "100px",
                }}
              >
                {course.courseName}
              </h4>
            </Tooltip>
            <span>{course.studentsCount} Tələbə </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActiveStudentsCard;
